import i18n from '../../../../i18n';

export const monthsArray = () => {
    const applyFormat = new Intl.DateTimeFormat(i18n.language, { month: 'long' }).format;
    return [...Array(12).keys()].map((m) => applyFormat(new Date(2021, m)));
};
